// src/pages/Partenariat.js
import React, { useState } from 'react';
import PartnershipForm from '../components/PartnershipForm'
import '../styles/Partenariat.css';

const Partenariat = () => {
    const [formData, setFormData] = useState({
        nom: '',
        entreprise: '',
        email: '',
        telephone: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Demande de partenariat :', formData);
        // Ici, vous pouvez envoyer les données vers votre backend
        alert('Merci pour votre demande de partenariat ! Nous vous contacterons prochainement.');
        setFormData({
            nom: '',
            entreprise: '',
            email: '',
            telephone: '',
            message: ''
        });
    };

    return (
        <div className="partenariat-container">
            <h1>Devenez Partenaire de Naninan</h1>
            <section className="preamble">
                <p>
                    Chez Naninan, nous croyons que le cinéma est une aventure collective. Nous recherchons des partenaires passionnés et innovants pour enrichir notre plateforme et offrir une expérience unique aux cinéphiles.
                </p>
                <p>
                    Pour devenir partenaire, nous attendons de vous :
                </p>
                <ul>
                    <li>Une passion pour le cinéma et l'innovation.</li>
                    <li>La volonté de collaborer pour créer des expériences mémorables.</li>
                    <li>Une proposition claire de valeur ajoutée pour notre communauté.</li>
                </ul>
                <p>
                    Que vous soyez une entreprise du secteur cinématographique, un média ou tout autre acteur désireux d’offrir une expérience inédite, nous sommes ouverts à toutes vos propositions !
                </p>
            </section>
            <section className="partenariat-form">
                <h2>Formulaire de Demande de Partenariat</h2>
                    <PartnershipForm />
            </section>
        </div>
    );
};

export default Partenariat;
